import React from 'react';
import {
  LipChinHero,
  AverageResultsDivider,
  HowLipChinWorks,
  SectionDivider,
  FacialHair,
  SEO,
} from '../../components';
import { graphql } from 'gatsby';
import './areas.css';

function LipChinPage() {
  return (
    <main id='lipnchin-page'>
      <LipChinHero />
      <AverageResultsDivider />
      <HowLipChinWorks />
      <FacialHair />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`Body Area | Lip & Chin | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
      description='Want smoother skin on your face? Try our lip and chin laser hair removal service. Book an appointment today and say hello to smooth skin!'
    />
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default LipChinPage;
